import { useFormik } from 'formik'

import { FormGroup, Input } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { Company, CompanyEditDTO } from 'modules/domain/company/types'
import { RequestError } from 'modules/errors'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { CommonFields } from '../../components/CommonFields'
import { CompanyRuDetailsModal } from './CompanyRuDetailsModal'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'

type Props = {
  onClose: () => void
  company: Company
  refreshCompany: (arg: boolean) => void
}

const getEditable = (company: Company) => {
  const { parent: _, ...rest } = company
  return { ...rest, parent: company.parent?.id }
}

export const CompanyRuEdit: FC<Props> = ({ onClose, company, refreshCompany }) => {
  const { t } = useTranslation('company')
  const [editProgress, editCompany] = useAProgress(
    (id: string, dto: Partial<CompanyEditDTO>) => apiClient.put<Company>(endpoints.company(id), dto),
    {
      eventName: 'edit',
      onSuccess: async () => {
        await refreshCompany(true)
        onClose()
      },
      onError: (err) => {
        const error = err as RequestError
        const { errors } = error
        formik.setErrors(errors)
      },
    },
  )

  const formik = useFormik<CompanyEditDTO>({
    initialValues: getEditable(company),
    enableReinitialize: true,
    onSubmit: (values) => editCompany(company.id, values),
  })

  return (
    <CompanyRuDetailsModal progress={editProgress} onClose={onClose} formik={formik}>
      {!company.inn && (
        <>
          <FormGroup label={t('common:company')} error={formik.errors.name}>
            <Input {...formik.getFieldProps('name')} invalid={!!formik.errors.name} />
          </FormGroup>
          <CommonFields.PersonalNumber formik={formik} />
        </>
      )}
    </CompanyRuDetailsModal>
  )
}
